import { c as _c } from "react/compiler-runtime";
import { IcoPencil16 } from '@onefootprint/icons';
import { Divider, Form, IconButton, TextInput, Tooltip } from '@onefootprint/ui';
import capitalize from 'lodash/capitalize';
import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { VendorIntegrationFormData } from '../../types';
import { formFieldKey, getIntegrationInputNodes, getLeafFields, type IntegrationInputNode, pathKey } from '../../utils/integration-schema';
type IntegrationOutputMappingProps = {
  outputSchema: unknown;
};
const IntegrationOutputMapping = t0 => {
  const $ = _c(51);
  const {
    outputSchema
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "externalApi.vendorIntegration.outputMapping"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const [filter, setFilter] = useState("");
  let filteredLeaves;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== filter || $[2] !== outputSchema || $[3] !== t) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const leaves = getLeafFields(getIntegrationInputNodes(outputSchema));
      let t10;
      bb1: {
        const q = filter.trim().toLowerCase();
        if (!q) {
          t10 = leaves;
          break bb1;
        }
        t10 = leaves.filter(leaf => pathKey(leaf.path).toLowerCase().includes(q));
      }
      filteredLeaves = t10;
      if (leaves.length === 0) {
        let t11;
        if ($[13] !== t) {
          t11 = t(_temp);
          $[13] = t;
          $[14] = t11;
        } else {
          t11 = $[14];
        }
        let t12;
        if ($[15] !== t11) {
          t12 = <p className="text-body-3 text-tertiary">{t11}</p>;
          $[15] = t11;
          $[16] = t12;
        } else {
          t12 = $[16];
        }
        t9 = t12;
        break bb0;
      }
      t7 = "flex flex-col gap-3";
      let t11;
      if ($[17] !== t) {
        t11 = t(_temp2);
        $[17] = t;
        $[18] = t11;
      } else {
        t11 = $[18];
      }
      let t12;
      if ($[19] !== t11) {
        t12 = <div className="text-label-3 text-primary">{t11}</div>;
        $[19] = t11;
        $[20] = t12;
      } else {
        t12 = $[20];
      }
      let t13;
      if ($[21] !== t) {
        t13 = t(_temp3);
        $[21] = t;
        $[22] = t13;
      } else {
        t13 = $[22];
      }
      let t14;
      if ($[23] !== t13) {
        t14 = <div className="text-body-3 text-tertiary">{t13}</div>;
        $[23] = t13;
        $[24] = t14;
      } else {
        t14 = $[24];
      }
      if ($[25] !== t12 || $[26] !== t14) {
        t8 = <div className="flex flex-col gap-0.5">{t12}{t14}</div>;
        $[25] = t12;
        $[26] = t14;
        $[27] = t8;
      } else {
        t8 = $[27];
      }
      t4 = "flex flex-col border border-tertiary rounded-md";
      let t15;
      if ($[28] !== t) {
        t15 = t(_temp4);
        $[28] = t;
        $[29] = t15;
      } else {
        t15 = $[29];
      }
      let t16;
      if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = event => setFilter(event.target.value);
        $[30] = t16;
      } else {
        t16 = $[30];
      }
      if ($[31] !== filter || $[32] !== t15) {
        t5 = <div className="p-3"><TextInput placeholder={t15} value={filter} onChange={t16} size="compact" /></div>;
        $[31] = filter;
        $[32] = t15;
        $[33] = t5;
      } else {
        t5 = $[33];
      }
      if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <Divider />;
        $[34] = t6;
      } else {
        t6 = $[34];
      }
      t2 = "flex flex-col px-3";
      t3 = filteredLeaves.map((leaf_0, index) => <Row key={pathKey(leaf_0.path)} leaf={leaf_0} isLast={index === filteredLeaves.length - 1} />);
    }
    $[1] = filter;
    $[2] = outputSchema;
    $[3] = t;
    $[4] = filteredLeaves;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    filteredLeaves = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[35] !== filteredLeaves.length || $[36] !== t) {
    t10 = filteredLeaves.length === 0 && <div className="py-3 text-body-3 text-tertiary">{t(_temp5)}</div>;
    $[35] = filteredLeaves.length;
    $[36] = t;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== t10 || $[39] !== t2 || $[40] !== t3) {
    t11 = <div className={t2}>{t3}{t10}</div>;
    $[38] = t10;
    $[39] = t2;
    $[40] = t3;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  let t12;
  if ($[42] !== t11 || $[43] !== t4 || $[44] !== t5 || $[45] !== t6) {
    t12 = <div className={t4}>{t5}{t6}{t11}</div>;
    $[42] = t11;
    $[43] = t4;
    $[44] = t5;
    $[45] = t6;
    $[46] = t12;
  } else {
    t12 = $[46];
  }
  let t13;
  if ($[47] !== t12 || $[48] !== t7 || $[49] !== t8) {
    t13 = <div className={t7}>{t8}{t12}</div>;
    $[47] = t12;
    $[48] = t7;
    $[49] = t8;
    $[50] = t13;
  } else {
    t13 = $[50];
  }
  return t13;
};
const Row = t0 => {
  const $ = _c(35);
  const {
    leaf,
    isLast
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "externalApi.vendorIntegration.outputMapping"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    control
  } = useFormContext();
  const [isEditing, setIsEditing] = useState(false);
  let t2;
  if ($[1] !== leaf.path) {
    t2 = pathKey(leaf.path);
    $[1] = leaf.path;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const dotPath = t2;
  let t3;
  if ($[3] !== leaf.path) {
    t3 = formFieldKey(leaf.path);
    $[3] = leaf.path;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const fieldName = `config.outputMappings.${t3}` as const;
  let t4;
  if ($[5] !== control || $[6] !== fieldName) {
    t4 = {
      control,
      name: fieldName
    };
    $[5] = control;
    $[6] = fieldName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const value = useWatch(t4) as string | undefined;
  let t5;
  if ($[8] !== dotPath || $[9] !== leaf.description) {
    t5 = leaf.description ? capitalize(leaf.description) : dotPath;
    $[8] = dotPath;
    $[9] = leaf.description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dotPath) {
    t6 = <span className="text-body-3 text-primary font-mono truncate block">{dotPath}</span>;
    $[11] = dotPath;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <Tooltip content={t5}>{t6}</Tooltip>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== fieldName || $[17] !== isEditing || $[18] !== t || $[19] !== value) {
    t8 = <div className="min-w-0">{isEditing ? <div onBlur={event => {
        if (!event.currentTarget.contains(event.relatedTarget as Node | null)) {
          setIsEditing(false);
        }
      }}><Form.Input name={fieldName} addon="data." size="compact" autoFocus={true} placeholder={t(_temp6)} /></div> : value ? <span className="text-body-3 text-primary font-mono truncate block">data.{value}</span> : <span className="text-body-3 text-tertiary">{t(_temp7)}</span>}</div>;
    $[16] = fieldName;
    $[17] = isEditing;
    $[18] = t;
    $[19] = value;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t) {
    t9 = t(_temp8);
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsEditing(_temp9);
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t9) {
    t11 = <IconButton icon={IcoPencil16} size="compact" variant="ghost" aria-label={t9} onClick={t10} />;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t7 || $[28] !== t8) {
    t12 = <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] gap-4 items-center py-2">{t7}{t8}{t11}</div>;
    $[26] = t11;
    $[27] = t7;
    $[28] = t8;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== isLast) {
    t13 = !isLast && <Divider />;
    $[30] = isLast;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t12 || $[33] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
};
export default IntegrationOutputMapping;
function _temp($) {
  return $.empty;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.subtitle;
}
function _temp4($_2) {
  return $_2.filterPlaceholder;
}
function _temp5($_3) {
  return $_3.noMatches;
}
function _temp6($) {
  return $.keyPlaceholder;
}
function _temp7($_0) {
  return $_0.unmapped;
}
function _temp8($_1) {
  return $_1.edit;
}
function _temp9(v) {
  return !v;
}